export default __webpack_public_path__ + "static/media/image-6.0c38ad16.webp";